var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"businesses-left",attrs:{"xs12":""}},[_c('AboutTile',{attrs:{"canViewAbout":true,"canViewChair":false,"canViewSponsors":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }